import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk'

let context: QuickSightEmbedding.EmbeddingContext | null = null

export const getEmbeddingContext = async () => {
  if (!context) {
    context = await QuickSightEmbedding.createEmbeddingContext()
  }
  return context
}
